import prodSvg from '@/assets/font-svg/prod.svg'
import prodHoverSvg from '@/assets/font-svg/prod_hover.svg'

export const ProductCenterRouteMap = {
  ProductCenter: 'product-center',
  AnimationRendering: 'animation-rendering',
  RenderingOfRenderings: 'rendering-of-renderings',
  DaYan: 'dayan',
  IpCopyright: 'ip-copyright',
  Outsourcing: 'outsourcing',
  CloudProduction: 'desktop',
  TaskManagement: 'task',
  NodeManagement: 'node',
  DongleManagement: 'dongle',
  ProfessionalRenderingUpdateRecord: 'professionalRenderingUpdateRecord',
  MaterialManagement: 'material',
}

const ProductCenter = {
  path: '/',
  name: ProductCenterRouteMap.ProductCenter,
  title: '产品',
  meta: {
    sort: 0,
    modules: 'auth',
    icon: prodSvg,
    activeIcon: prodHoverSvg,
    permission: 'product',
  },
  children: [
    {
      name: ProductCenterRouteMap.AnimationRendering,
      title: '动画渲染',
      meta: {
        icon: 'icon-user',
        showSubiems: false,
        permission: 'animation',
      },
      children: [
        {
          name: ProductCenterRouteMap.TaskManagement,
          title: '作业管理',
          meta: {
            icon: 'icon-user',
            showSubiems: false,
            permission: 'task:root',
          },
          children: [],
        },
        {
          name: ProductCenterRouteMap.NodeManagement,
          title: '节点机管理',
          meta: {
            icon: 'icon-user',
            showSubiems: false,
            permission: 'node:root',
          },
          children: [],
        },
        {
          name: ProductCenterRouteMap.DongleManagement,
          title: '加密狗管理',
          meta: {
            icon: 'icon-user',
            showSubiems: false,
            permission: 'device:root',
          },
          children: [],
        },
      ],
    },
    {
      name: ProductCenterRouteMap.RenderingOfRenderings,
      title: '效果图渲染',
      meta: {
        icon: 'icon-user',
        showSubiems: false,
        permission: 'picture',
      },
      children: [
        {
          name: ProductCenterRouteMap.TaskManagement,
          title: '作业管理',
          meta: {
            icon: 'icon-user',
            showSubiems: false,
            permission: 'picture:root',
          },
          children: [],
        },
        {
          name: ProductCenterRouteMap.NodeManagement,
          title: '节点机管理',
          meta: {
            icon: 'icon-user',
            showSubiems: false,
            permission: 'picture:node:root',
          },
          children: [],
        },
      ],
    },
    {
      name: ProductCenterRouteMap.DaYan,
      title: '大雁云',
      meta: {
        icon: 'icon-user',
        showSubiems: false,
        permission: 'dayan',
      },
      children: [
        {
          name: ProductCenterRouteMap.TaskManagement,
          title: '作业管理',
          meta: {
            icon: 'icon-user',
            showSubiems: false,
            permission: 'dyy:task:root',
          },
          children: [],
        },
        {
          name: ProductCenterRouteMap.NodeManagement,
          title: '节点机管理',
          meta: {
            icon: 'icon-user',
            showSubiems: false,
            permission: 'dayan:node',
          },
          children: [],
        },
      ],
    },
    {
      name: ProductCenterRouteMap.IpCopyright,
      title: '版权云',
      meta: {
        icon: 'icon-user',
        showSubiems: false,
        permission: 'copyright',
      },
      children: [],
    },
    {
      name: ProductCenterRouteMap.Outsourcing,
      title: '外包管理',
      meta: {
        icon: 'icon-user',
        showSubiems: false,
        permission: 'outsourcing:root',
      },
      children: [],
    },
    {
      name: ProductCenterRouteMap.CloudProduction,
      title: '云制作管理',
      meta: {
        icon: 'icon-user',
        showSubiems: false,
        permission: '',
      },
      children: [],
    },
  ],
}

export default ProductCenter
